var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 18.8332H3.33398C2.89196 18.8332 2.46803 18.6576 2.15547 18.345C1.84291 18.0325 1.66732 17.6085 1.66732 17.1665V3.83317C1.66732 3.39114 1.84291 2.96722 2.15547 2.65466C2.46803 2.3421 2.89196 2.1665 3.33398 2.1665H13.334C13.776 2.1665 14.1999 2.3421 14.5125 2.65466C14.8251 2.96722 15.0007 3.39114 15.0007 3.83317V17.1665C15.0007 17.6085 15.1762 18.0325 15.4888 18.345C15.8014 18.6576 16.2253 18.8332 16.6673 18.8332ZM16.6673 18.8332C17.1093 18.8332 17.5333 18.6576 17.8458 18.345C18.1584 18.0325 18.334 17.6085 18.334 17.1665V9.6665C18.334 8.74984 17.584 7.99984 16.6673 7.99984H15.0007",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99935 12.1665H11.666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 15.5H11.666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 5.5H4.99935M4.99935 8.83333H11.666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcons);
export default __webpack_public_path__ + "static/media/Menu Icons.043073330c92ef885f61d7a3e5ec3927.svg";
export { ForwardRef as ReactComponent };